module.exports = {
    Auth: {
        Cognito: {
            userPoolId: process.env.VUE_APP_USER_POOL_ID,
            userPoolClientId: process.env.VUE_APP_USER_POOL_CLIENT_ID,
        }
    }
}
